import { format } from "date-fns";

export const COLUMNS = [
    {
        Header: 'Name',
        accessor: 'name'
    },
]